export default function extractValues(obj, unique = false) {
  const values = []
  const visited = new WeakSet()

  function collect(current) {
    if (!current || typeof current !== 'object') return

    if (visited.has(current)) return

    visited.add(current)

    for (const key in current) {
      const value = current[key]
      if (value && typeof value === 'object') {
        collect(value)
      } else {
        values.push(value)
      }
    }
  }

  collect(obj)
  return unique ? [...new Set(values)] : values
}
